import { render, staticRenderFns } from "./viewer-pdf.vue?vue&type=template&id=9ee2afb0&scoped=true"
import script from "./viewer-pdf.vue?vue&type=script&lang=js"
export * from "./viewer-pdf.vue?vue&type=script&lang=js"
import style0 from "./viewer-pdf.vue?vue&type=style&index=0&id=9ee2afb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee2afb0",
  null
  
)

export default component.exports